import { render, staticRenderFns } from "./PopularCategoriesCarousel.vue?vue&type=template&id=3d8e8610&"
import script from "./PopularCategoriesCarousel.vue?vue&type=script&lang=ts&"
export * from "./PopularCategoriesCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports